<!--
 * @Author: Merlin
 * @Date: 2024-05-06 17:58:57
 * @LastEditors: Merlin
 * @LastEditTime: 2024-08-13 17:17:27
 * @Description: 这是滑竿组件 TODO 待同步 

-->
<template>
    <div class="slider mt-[25px]"
        :style="{
            'pointer-events': (isSubmiting || showHistory) ? 'none' : 'auto',
            'margin-left': marginLeft,
        }"
    >
        <!-- ↓ 此元素是 .w-full = 100%宽度 -->
        <div mark="bar-background"
            :ref="(el) => (sliderRef = el)"
            :class="[isUnder ? 'bg-error' : 'bg-btnPrimary']"
            class="h-[10px] w-full relative rounded-full items-center flex"
        >
            <!-- thumb（滑块容器） --> 
            <div
                :ref="(el) => (thumbRef = el)"
                class="z-10 absolute left-auto right-[17px] w-full"
                v-bind:class="[thumbIsDown ? '' : 'duration-200']"
                :style="{ transform: `translate(${progress}%, 0)` }"
            >
                <!-- ↓ 滑块 -->
                <span
                    @mousedown="setStatus(true)"
                    @touchstart="setStatus(true)"
                    @mouseup="setStatus(false)"
                    @touchend="setStatus(false)"
                    class="h-[30px] cursor-pointer ring-4 ring-white ring-opacity-20 w-[30px] flex items-center justify-center font-bold bg-white rounded-[7px] text-black"
                >
                    {{ progress }}
                </span>
            </div>
            <!-- progress -->
            <div>
                <div
                    class="bg-btnPrimary h-full absolute left-0 bottom-0 rounded-l-full"
                    v-bind:class="[
                        thumbIsDown ? '' : 'duration-200',
                        !isUnder ? 'bg-error' : 'bg-btnPrimary',
                    ]"
                    :style="{ width: `${progress}%` }"
                ></div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
    progress: {
        type: Number,
        required: true,
    },
    isUnder: {
        type: Boolean,
        required: false,
        default: false
    },
    isSubmiting: {
        type: Boolean,
    },
    showHistory: {
        type: Boolean,
    },
});

const emit = defineEmits(['update:progress']);
const thunmbIsDown = ref(false);
const thumbIsDown = ref(false); // 滑块按下状态 
const thumbRef = ref(null); // 内层：滑块容器 dom 
const sliderRef = ref(null); // 外层：滑条滑轨 dom 

// ↓ 计算值 
const maxValue = computed(() => (props.isUnder ? 95 : 98));
const minValue = computed(() => (props.isUnder ? 1 : 4));
const marginLeft = computed(() => {
    const {showHistory, isUnder, progress} = props;
    if (showHistory && isUnder && progress <= 5){
        const iStep = 6 - progress;
        return iStep * (4) + 'px';
    }
    return '0px';
});

// ↓ 用于传值（赋值）的方法  
const fnToSetProgress = (xx:number)=>{
    // ↓ 防止点击到界外，重要！
    if (xx > 1) return;
    const iValue = Math.max(
        Math.min(Math.round(xx * 100), maxValue.value),
        minValue.value
    );
    emit(
        'update:progress',
        iValue,
    );
};

// ↓ 设定状态 
const setStatus = (bValue:boolean) => {
    if (0 && import.meta.dev){
        console.log("已经：", bValue ? '按下' : '抬起了');
    }
    thumbIsDown.value = !!bValue;
}

// ↓ 处理移动
const fnMovingAction = (ev)=>{
    if (!thumbIsDown.value) return;
    ev.preventDefault();
    console.log(ev.type, '已经触发了, 默认事件已经被阻止');
    // ↑ 把 preventDefault() 放第2行，在事件相关时进行防止默认事件   
    const rect = sliderRef.value!.getBoundingClientRect();
    let clientX = ev.clientX ?? ev.touches[0].clientX;
    let xx = (clientX - rect.left) / rect.width;
    fnToSetProgress(xx);
};

// ↓ 用户事件
const oFnLib = {
    mousemove: fnMovingAction,
    touchmove: fnMovingAction,
    mouseup: () => setStatus(false),
    touchend: () => setStatus(false),
};

// ↓ 用于入场时绑定鼠标事件，离场时解绑 
const fnBiding = (bAction=false)=>{
    const sAction = (
        bAction
        ? 'addEventListener'
        : 'removeEventListener'
    );
    const oOptions = { passive: false }; // ←默认值 🤣
    Object.entries(oFnLib).forEach(aCur=>{
        const [sEvent, fnMethod] = aCur;
        document[sAction](sEvent, fnMethod, oOptions);
    });
};

// ↓ 横杆被点击 
const fnActionOnSlider = (ev) => {
    ev.preventDefault();
    console.log("横杆事件：", ev.type); 
    setStatus(true);
    const rect = sliderRef.value!.getBoundingClientRect();
    let clientX = ev.clientX ?? ev.touches[0].clientX;
    const xx = (clientX - rect.left) / rect.width;
    fnToSetProgress(xx);
};

onMounted(() => {
    if (!thumbRef.value) {
        return;
    }
    fnBiding(true);
    // ↑ 监听 document
    // ↓ 监听特定 dom 操作 --------------------------------------------- 
    // ↓ 内层滑块容器的 DOM 鼠标事件 
    // thumbRef.value.addEventListener('touchstart', (ev) => {
    //     setStatus(true);
    //     const rect = sliderRef.value!.getBoundingClientRect();
    //     const xx = (ev.touches[0].clientX - rect.left) / rect.width;
    //     fnToSetProgress(xx);
    // });
    // ↓ 外层 DOM 鼠标事件  
    const oOptions = {
        passive: false, // true 表示将不会调用 preventDefault() 
        capture: true, // true 表示在捕获阶段调用，触发提前了
    };
    sliderRef.value.addEventListener('mousedown', fnActionOnSlider, oOptions);
    sliderRef.value.addEventListener('touchstart', fnActionOnSlider, oOptions);
});

onUnmounted(() => {
    fnBiding(false);
});

watch(
    () => props.isUnder,
    (value) => {
        if (value) {
            if (props.progress > 95) {
                emit('update:progress', 95);
            }
        } else {
            if (props.progress < 4) {
                emit('update:progress', 4);
            }
        }
    },
    { immediate: true },
);

// ↓ 这是被 fnBiding() 取代的方法，将来删除
// ↓ 写于 2024.05.21 17:49:2 星期二 
// document.addEventListener('mousemove', (e) => {
//     if (thumbIsDown.value === false) return;
//     const rect = sliderRef.value!.getBoundingClientRect();
//     let x = (e.clientX - rect.left) / rect.width;
//     fnToSetProgress(x);
// });
// document.addEventListener('touchmove', (e) => {
//     if (thumbIsDown.value === false) return;
//     const rect = sliderRef.value!.getBoundingClientRect();
//     const x = (e.touches[0].clientX - rect.left) / rect.width;
//     fnToSetProgress(x);
// });
// document.addEventListener('mouseup', () => {
//     thumbIsDown.value = false;
// });
// document.addEventListener('touchend', () => {
//     thumbIsDown.value = false;
// });

</script>

<style scoped lang="scss">
.slider {
    line-height: 1.5;
}
.slider::after {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHAQMAAAALYk4gAAAABlBMVEUAAAAnMEVBlWpGAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjaGDARAAmlQOB8JPswAAAAABJRU5ErkJggg==);
    background-repeat: repeat-x;
    content: '';
    display: block;
    height: 7px;
    margin-top: 20px;
    width: 100%;
    margin-top: 20px;
    @media (max-width: 576px){
        display: none;
    }
}
</style>


